import React from 'react'
import AceEditor from 'react-ace'
import 'brace/mode/text'
import 'brace/mode/json'
import 'brace/mode/javascript'
import 'brace/mode/xml'
import 'brace/mode/ejs'
import 'brace/theme/xcode'
import 'brace/mode/json'
import 'brace/mode/yaml'
import 'brace/theme/xcode'
import 'brace/ext/searchbox'

const CodeEditor = (props) => {
  return (
    <AceEditor {...props} />
  )
}

export {CodeEditor}

export default CodeEditor

